import { render, staticRenderFns } from "./AtePlatRace.vue?vue&type=template&id=7b51e779"
import script from "./AtePlatRace.vue?vue&type=script&lang=js"
export * from "./AtePlatRace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports